var _circle, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8KeepClean50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.79,21l-1.6,16H17.81l-1.6-16H31.79 M34,19H14l1.82,18.199C15.922,38.221,16.782,39,17.81,39 h12.38c1.028,0,1.888-0.779,1.99-1.801L34,19L34,19z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 18.007,
    x: 20.251,
    y: 19.996,
    fill: "#fff",
    transform: "rotate(-1.621 21.237 29.01)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18.007,
    height: 2,
    x: 17.745,
    y: 27.999,
    fill: "#fff",
    transform: "rotate(-88.436 26.749 29)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 16,
    y: 25,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 16,
    y: 31,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6.364,
    height: 4.95,
    x: 17.818,
    y: 8.525,
    fill: "#fff",
    transform: "rotate(-45.001 21 11)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4.773,
    height: 3.712,
    x: 25.614,
    y: 12.144,
    fill: "#fff",
    transform: "rotate(-45.001 28 14)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8KeepClean50);
export default __webpack_public_path__ + "static/media/icons8-keep-clean-50.94bd01a74b7a256bb53a3d4f80126aae.svg";
export { ForwardRef as ReactComponent };